 // build in uix/config/domain_code.js
import now from 'performance-now'

export const IMPORT_LOADER = (dname, load) => {
  switch (dname) {
    
  }
}
